import isPlainObject from "lodash/isPlainObject";
import type { AbstractIntlMessages } from "next-intl";

const isEmptyString = (value: unknown): boolean => typeof value === "string" && value.trim() === "";

const isMessagesObject = (value: unknown): value is AbstractIntlMessages => isPlainObject(value);

function cleanTranslationValue(value: unknown): unknown {
  if (Array.isArray(value)) {
    return value.map(cleanTranslationValue).filter((item) => {
      if (isEmptyString(item)) return false;
      if (isMessagesObject(item)) return Object.keys(item).length > 0;
      return true;
    });
  }

  if (!isMessagesObject(value)) {
    return value;
  }

  const result: Record<string, unknown> = {};

  for (const [key, entry] of Object.entries(value)) {
    if (isEmptyString(entry)) continue;

    if (isMessagesObject(entry) || Array.isArray(entry)) {
      const cleaned = cleanTranslationValue(entry);
      if (Array.isArray(cleaned) || (isMessagesObject(cleaned) && Object.keys(cleaned).length > 0)) {
        result[key] = cleaned;
      }
    } else {
      result[key] = entry;
    }
  }

  return result;
}

export function removeEmptyTranslations(obj: AbstractIntlMessages): AbstractIntlMessages {
  const cleaned = cleanTranslationValue(obj);
  return isMessagesObject(cleaned) ? cleaned : {};
}
